import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { TopHeaderCustomComponent } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProjectPreferences/TopHeaderCustomComponent/topHeaderCustomComponent';
import { ProjectPreferences } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProjectPreferences/components/projectPreferences';
import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';

export const ProjectPreferencesPage = () => {
    useFullStoryPageView({ pageName: executionConfig.projectPreferences.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TopHeaderCustomComponent pageTitle={executionConfig.projectPreferences.title} />
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader
                        showBack={true}
                        pageTitle={executionConfig.projectPreferences.title}
                    ></ProgramTopHeader>
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <ProjectPreferences />
            </MainContent>
        </PageContainer>
    );
};
